export default class footerTemplate {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/maileditor/footer.html')
        }
    }
};